// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__2YH5f","header":"styles_header__3pMdt","back":"styles_back__2cBrP","title":"styles_title__apLHl","content":"styles_content__3pJi9"};